import React from 'react'

import { twMerge } from 'tailwind-merge'

interface AvatarSkeletonProps {
  width?: number
  height?: number
  className?: string
  nameClassName?: string
  noName?: boolean
}

export interface SkeletonProps {
  className?: string
}

export const AvatarSkeleton: React.FC<AvatarSkeletonProps> = ({
  width = 28,
  height = 28,
  className,
  nameClassName,
  noName = false,
}) => {
  return (
    <div className="flex items-center justify-center gap-x-2 animate-pulse">
      <div
        className={twMerge(
          'bg-primary-300 dark:bg-primary-700 rounded-full',
          className,
        )}
        style={{ width, height, minWidth: width, minHeight: height }}
      />
      {!noName && (
        <div
          className={twMerge(
            'w-32 h-3 bg-primary-300 dark:bg-primary-700 rounded-md',
            nameClassName,
          )}
        />
      )}
    </div>
  )
}

export const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
  return (
    <div
      className={twMerge(
        'animate-pulse bg-primary-300 dark:bg-primary-700 rounded-md',
        className,
      )}
    />
  )
}
